import { useEffect, useState } from "react";
import api, { errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { toast } from "sonner";

export default function PayoutPage() {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0,7));
  const load = () => api.get(`/admin/incentive-payout?month=${month}`).then(r => setData(r.data)).catch(e => toast.error(errorMessage(e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [month]);
  const inr = (n) => `₹${Number(n||0).toLocaleString("en-IN")}`;
  const pay = async (row) => {
    try {
      const { data: r } = await api.post(`/admin/incentive-payout/${row.staff_id}/pay?month=${month}`);
      toast.success(r.already_paid ? `Already paid: ${row.staff_name}` : `Marked paid: ${row.staff_name} — ${inr(row.total_payable)}`);
      load();
    } catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="space-y-6" data-testid="payout-page">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="font-heading text-xl text-white">Incentive Payout · {data?.month || month}</div>
          <div className="text-sm text-slate-500">Normal target incentive (staff who hit 100%) + Referral bonuses. Click Pay to record.</div>
        </div>
        <Input type="month" value={month} onChange={e => setMonth(e.target.value)} data-testid="payout-month" className="bg-slate-950 border-slate-700 max-w-[180px]"/>
      </div>
      <div className="card-surface p-6">
        <div className="grid md:grid-cols-3 gap-4 mb-6">
          <div><div className="text-xs uppercase tracking-widest text-slate-500">Grand Total</div><div className="font-display text-2xl text-amber-400 mt-1">{inr(data?.grand_total)}</div></div>
          <div><div className="text-xs uppercase tracking-widest text-slate-500">Staff Eligible</div><div className="font-display text-2xl text-white mt-1">{(data?.rows || []).length}</div></div>
        </div>
        <Table>
          <TableHeader><TableRow className="border-white/5"><TableHead>Staff</TableHead><TableHead>Role</TableHead><TableHead>Target %</TableHead><TableHead>Target Incentive</TableHead><TableHead>Referral Cases</TableHead><TableHead>Referral Bonus</TableHead><TableHead>Total Payable</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {(data?.rows || []).map(r => (
              <TableRow key={r.staff_id} className="border-white/5" data-testid={`payout-row-${r.staff_id}`}>
                <TableCell><div className="text-white">{r.staff_name}</div><div className="text-xs text-slate-500 font-mono-alt">{r.staff_phone}</div></TableCell>
                <TableCell><Badge className="bg-slate-800 text-slate-300">{(r.sub_role || r.staff_role || "").replace("_"," ")}</Badge></TableCell>
                <TableCell>{r.target_pct !== null && r.target_pct !== undefined ? (
                  <span className={r.target_hit ? "text-emerald-400 font-bold" : r.target_pct >= 50 ? "text-amber-400" : "text-red-400"}>{r.target_pct}%</span>
                ) : <span className="text-slate-600">—</span>}</TableCell>
                <TableCell className="font-mono-alt text-emerald-400">{r.target_incentive > 0 ? inr(r.target_incentive) : "—"}</TableCell>
                <TableCell className="text-slate-300">{r.referral_cases}</TableCell>
                <TableCell className="font-mono-alt text-amber-400">{r.referral_bonus > 0 ? inr(r.referral_bonus) : "—"}</TableCell>
                <TableCell className="font-mono-alt text-white font-bold">{inr(r.total_payable)}</TableCell>
                <TableCell>{r.total_payable > 0 && (
                  <Button size="sm" onClick={() => pay(r)} data-testid={`payout-pay-${r.staff_id}`} className="bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-full">Pay</Button>
                )}</TableCell>
              </TableRow>
            ))}
            {(!data || data.rows.length === 0) && <TableRow><TableCell colSpan={8} className="text-center text-slate-500 py-8">No payouts for this month yet</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
